import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from "@/views/new/Index.vue";
import About from "@/views/new/About.vue";
import Solution1 from "@/views/new/solutions/Solution1.vue";
import Solution2 from "@/views/new/solutions/Solution2.vue";
import Solution3 from "@/views/new/solutions/Solution3.vue";

import Chergpt from "@/views/new/products/chergpt.vue";
import AI from "@/views/new/products/ai.vue";
import DSCP from "@/views/new/products/dscp.vue";
import CDP from "@/views/new/products/cdp.vue";
import DataService1 from "@/views/new/products/data-service1.vue";
import DataService2 from "@/views/new/products/data-service2.vue";
import Base from "@/views/new/products/base.vue";
import CloudSafety from "@/views/new/products/cloud-safety.vue";
import DeviceSafety from "@/views/new/products/device-safety.vue";
import MailSafety from "@/views/new/products/mail-safety.vue";


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Index',
        component: Index,
        meta: {
            title: '首页 | 船水技术',
        },
    },
    {
        path: '/solution1',
        name: 'Solution1',
        component: Solution1,
        meta: {
            title: '金融解决方案 | 船水技术',
        },
    },
    {
        path: '/solution2',
        name: 'Solution2',
        component: Solution2,
        meta: {
            title: '运营商解决方案 | 船水技术',
        },
    },
    {
        path: '/solution3',
        name: 'Solution3',
        component: Solution3,
        meta: {
            title: '制造解决方案 | 船水技术',
        },
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: '关于我们 | 船水技术',
        },
    },
    {
        path: '/chergpt',
        name: 'Chergpt',
        component: Chergpt,
        meta: {
            title: 'CherGPT—AI原生赋能平台 | 船水技术',
        },
    },
    {
        path: '/ai',
        name: 'AI',
        component: AI,
        meta: {
            title: 'AI服务 | 船水技术',
        },
    },
    {
        path: '/dscp',
        name: 'DSCP',
        component: DSCP,
        meta: {
            title: '数据安全管控平台 | 船水技术',
        },
    },
    {
        path: '/cdp',
        name: 'CDP',
        component: CDP,
        meta: {
            title: '客户数据平台 | 船水技术',
        },
    },
    {
        path: '/data-service1',
        name: 'DataService1',
        component: DataService1,
        meta: {
            title: '数据治理咨询与实施服务 | 船水技术',
        },
    },
    {
        path: '/data-service2',
        name: 'DataService2',
        component: DataService2,
        meta: {
            title: '数字化应用开发 | 船水技术',
        },
    },
    {
        path: '/base',
        name: 'base',
        component: Base,
        meta: {
            title: '基础架构软硬件 | 船水技术',
        },
    },
    {
        path: '/cloud-safety',
        name: 'CloudSafety',
        component: CloudSafety,
        meta: {
            title: '云安全 | 船水技术',
        },
    },
    {
        path: '/device-safety',
        name: 'DeviceSafety',
        component: DeviceSafety,
        meta: {
            title: '终端安全 | 船水技术',
        },
    },
    {
        path: '/mail-safety',
        name: 'MailSafety',
        component: MailSafety,
        meta: {
            title: '邮件安全 | 船水技术',
        },
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
    window.scrollTo(0, 0)
});

export default router
